export default "__VITE_ASSET__d75bce76__"